import User from '@modules/User';
import Icon from '@components/common/Icon';
import ProductSearch from '../ProductSearch';

const ALLERGENS_URL = '/resources/product-allergens';

// Restore the catalog-only header composition from fb51b8be4 using current shared components.
const LegacySearchSuggestions = ( {initialQuery, navigate} ) => {
    const allergenLabel = upi.i18n.getTextFromKey( 'lbl-Allergens', 'Allergens' );
    const allergenTerms = upi.i18n.getTextFromKey( 'keywords-Allergen',
        'allergen, allergens, allergic, allergies, allergy' ).trim().toLowerCase();
    const allergenTermsList = allergenTerms.split( ',' ).map( term => term.trim() );

    return (
        <ProductSearch
            initialQuery={initialQuery}
            showAllSkus={User.isTamProxy()}
            showBrandFamily={true}
            keywordRedirects={[{terms: allergenTerms, label: allergenLabel, url: ALLERGENS_URL}]}
            onSubmit={( event, query ) => {
                event.preventDefault();
                if ( query && allergenTermsList.includes( query.trim().toLowerCase() ) ) {
                    navigate( ALLERGENS_URL );
                }
            }}
        >
            {() => <div>
                <div id="search-bar--header" className="flex w-full lg:flex-1 p-2 md:p-0 border-b border-solid border-grey-light md:border-none">
                    <ProductSearch.Input id="search-query--header" placeholder="Keyword / Item#"/>
                    <button type="button" data-action="search-bar-toggle--mobile"
                            className="md:hidden px-2 self-center text-lg text-sky-blue">
                        {upi.i18n.getTextFromKey( 'wrd-Cancel', 'Cancel' )}
                    </button>
                </div>
                <div className="absolute w-full shadow-md bg-white">
                    <ProductSearch.Results
                        noResultsClass="mt-8 p-12 text-center text-xl border-t border-solid border-grey-lighter"
                        groupLabelClass="block px-4 py-2 bg-white font-bold txt-c3 border-b border-solid border-grey-lighter"
                    >
                        {results => <ProductSearch.ResultsPane>
                            <div className="absolute pin-t pin-r flex">
                                <a href="/resources/product-instructions" className="flex items-center py-2 px-3 border-l border-solid border-grey-lighter">
                                    <Icon.ui name="ifu" className="mr-1" center/>
                                    <span className="hidden lg:block pr-1">Find a</span> Product IFU
                                </a>
                                <a href="/resources/safety-data-sheets" className="flex items-center py-2 px-3 border-l border-solid border-grey-lighter">
                                    <Icon.ui name="sds" className="mr-1" center/>
                                    <span className="hidden lg:block pr-1">Find a</span> Product SDS
                                </a>
                            </div>
                            {results}
                        </ProductSearch.ResultsPane>}
                    </ProductSearch.Results>
                </div>
            </div>}
        </ProductSearch>
    );
};

export default LegacySearchSuggestions;
